import React from "react";

import { Button, Text, VStack } from "@chakra-ui/react";

import { NamedLink } from "@/components/common/navigation/NamedLink";

import { useCrudListContext } from "./CrudListContext";

export const CrudListEmptyTableContent: React.FC = () => {
  const { createRouteLabel, createRouteName, createRouteParams } =
    useCrudListContext();

  return (
    <VStack spacing={4}>
      <Text>No Data To Display</Text>
      {createRouteName && (
        <Button
          as={NamedLink}
          name={createRouteName}
          queryParams={createRouteParams}
        >
          {createRouteLabel}
        </Button>
      )}
    </VStack>
  );
};
